import React from 'react';
import { renderIntlLabel } from '@/utils';
import noCouponUrl from './img/no_coupon.png';
import styles from './index.module.scss';

const NoCouponData = () => {
  return (
    <>
      <div className={styles.noData}>
        <img src={noCouponUrl} alt={renderIntlLabel('guest_msg_no_coupon')} />
        <div>{renderIntlLabel('guest_msg_no_coupon')}</div>
      </div>
    </>
  );
};

export default NoCouponData;
